import React, { useState } from "react";
import ReservationForm from "./ReservationForm";
import QRCodePopup from "../qr/QRCodePopup";
import RegistrationGate from "../registration/RegistrationGate";
import { LockIcon, WarnIcon } from "../art/Icons";
import { ACTIVITIES } from "../../config/activities";
import { EVENT } from "../../config/event";
import { useCapacitySync } from "../../hooks/useCapacitySync";
import { useRegistrationClock } from "../../hooks/useRegistrationClock";
import { getStoredAccessCode } from "../../lib/registration";

const SYNC_DELAY_MS = 500;

const ReservationPage = () => {
  const { isSyncing, syncResult } = useCapacitySync(true, SYNC_DELAY_MS);
  const [qrReservation, setQrReservation] = useState(null);
  const { isOpen, timeLeft } = useRegistrationClock();
  const [hasAccessCode, setHasAccessCode] = useState(() => Boolean(getStoredAccessCode()));
  const canReserve = isOpen || hasAccessCode;
  // Forms re-fetch availability once the backend has recalculated capacities.
  const refreshKey = syncResult?.timestamp ?? "";

  return (
    <>
      <div className="rhead">
        <span className="kicker">Rezervace</span>
        <h1 className="display-h1">FAKULTA MRTVÝCH</h1>
        <p className="sub">LA MUERTE, LA MUERTE, LA MUERTE…</p>
        <p className="lead">
          Připojte se k nám v Zemi vzpomínek, kterou vás provede La Muerte! Vyplňte formulář níže a zarezervujte si
          místo v jedné z aktivit. Dokážeš splnit všechny úkoly a vrátit se mezi živé?
        </p>
      </div>

      {canReserve ? (
        <>
          {isSyncing && (
            <p className="msg info mx-auto mb-4 max-w-[860px]" role="status">
              <span className="spinner" />
              Synchronizuji kapacitu slotů…
            </p>
          )}

          <div className="notice red">
            <WarnIcon />
            <div>
              <h4>Důležité upozornění</h4>
              <p>
                Na stezku i aktivity se dostavte alespoň s 15minutovým předstihem, jinak vám budou brány Země
                vzpomínek nenávratně uzavřeny.
              </p>
            </div>
          </div>
          <div className="notice gold">
            <LockIcon />
            <div>
              <h4>Zapamatujte si název týmu a heslo</h4>
              <p>
                Tyto údaje jsou nutné pro zrušení nebo změnu času rezervace. Informace jsou uvedeny v QR kódu, který si
                pečlivě uschovejte. Při přihlášení na všechny aktivity doporučujeme stejné heslo. Bez názvu týmu a
                hesla nebudeme moci najít vaši rezervaci.
              </p>
            </div>
          </div>

          <div className="forms">
            {ACTIVITIES.map((activity) => (
              <ReservationForm
                key={activity.key}
                activity={activity}
                refreshKey={refreshKey}
                onReserved={setQrReservation}
              />
            ))}
          </div>
        </>
      ) : (
        <RegistrationGate timeLeft={timeLeft} onUnlocked={() => setHasAccessCode(true)} />
      )}

      <div className="contact">
        <h4>Kontakt ze Země vzpomínek</h4>
        <p>
          V případě problémů s rezervací kontaktujte průvodce: <b>{EVENT.phone}</b>
        </p>
      </div>

      <QRCodePopup isOpen={Boolean(qrReservation)} onClose={() => setQrReservation(null)} reservationData={qrReservation} />
    </>
  );
};

export default ReservationPage;
